import { Icon } from "@iconify/react";
export const TopBarIcon = [
  {
    icon: <Icon icon="bxl:linkedin" />,
    alt: "audit Image",
    link: "https://www.linkedin.com/company/qubitars/",
  },
  {
    icon: <Icon icon="cib:facebook-f" />,
    alt: "audit Image",
    link: "https://www.facebook.com/qubitars",
  },
  {
    icon: <Icon icon="ant-design:instagram-outlined" />,
    alt: "audit Image",
    link: "https://www.instagram.com/qubitars/",
  },
  {
    icon: <Icon icon="cib:skype" />,
    alt: "audit Image",
    link: "https://join.skype.com/invite/vSZo0hqcXPdn",
  },
];
